<template>
  <li>
    <router-link
      :to="{
        name: 'selected',
        params: {
          site: questionsConfig.name,
          slug: getSlug(program.permalink)
        }
      }"
      class="block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
    >
      <div class="flex items-center px-4 py-4 sm:px-6 list-item">
        <div class="w-full flex-col flex">
          <div class="w-full flex-wrap md:flex-no-wrap flex px-4">
            <div
              class="flex-1 text-2xl font-bold leading-7 font-medium text-primary"
            >
              {{ program.title }}
            </div>

            <div class="">
              <div
                class="flex items-center text-sm text-gray-500 bg-gray-200 h-6 p-4 rounded-full"
              >
                <svg
                  class="h-4 w-4"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                  ></path>
                </svg>
                {{ program.foerdergeber.name }} ({{
                  program.foerdergeber.ebene_label
                }})
              </div>
            </div>
          </div>
          <div class="w-full flex-1 px-4">
            <div class="flex items-center text-base leading-8 text-gray-500">
              <div class="" v-html="program.kurzbeschreibung"></div>
            </div>
          </div>
          <div v-if="showSponsoringTable" class="w-full flex-1 px-4">
            <div
              v-if="program.foerderquote"
              class="mt-2 flex items-center text-base leading-8 text-gray-500"
            >
              <span class="font-bold pr-2">Förderquote:</span>
              {{ program.foerderquote }}% (mind.
              {{ formatMoney(program.min_foerderhoehe) }} / max.
              {{ formatMoney(program.max_foerderhoehe) }} )
            </div>
          </div>
          <div
            v-if="program.antragsstelle_kurzbezeichnung"
            class="w-full flex-1 px-4"
          >
            <div
              class="mt-2 flex items-center text-base leading-8 text-gray-500"
            >
              <span class="font-bold pr-2">Antragsstelle:</span>
              {{ program.antragsstelle_kurzbezeichnung }}
            </div>
          </div>
        </div>
        <div>
          <!-- Heroicon name: chevron-right -->
          <svg
            class="h-5 w-5 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fill-rule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
      </div>
    </router-link>
  </li>
</template>

<script>
import { get } from 'vuex-pathify'

export default {
  name: 'ListItem',
  props: {
    program: Object
  },
  computed: {
    questionsConfig: get('questions/config'),
    showSponsoringTable() {
      return false
    }
  },
  methods: {
    getSlug(url) {
      return url.substring(url.lastIndexOf('/') + 1)
    },
    formatMoney(value) {
      const formatter = new Intl.NumberFormat('de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      })

      return formatter.format(value)
    }
  }
}
</script>

<style lang="scss" scoped></style>
